export default __webpack_public_path__ + "static/visualma-vr-ar-3d-d366db374f62052f2a9c9f991fd91b33.jpg";